import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Scale } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ProcuracaoForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [specific, setSpecific] = useState(false);
  const [f, setF] = useState({ finalidade:"", processo:"", parte_contraria:"", orgao:"", poderes_especificos:"" });
  const [loading, setLoading] = useState(false);
  const submit = async () => {
    setLoading(true);
    try {
      const payload = { type: "procuracao", client_id: id, procuracao: specific ? f : {} };
      const r = await api.post("/documents/generate", payload);
      navigate(`/documents/${r.data.id}`);
    } catch (e) { toast.error("Erro ao gerar procuração"); }
    finally { setLoading(false); }
  };
  return (
    <div className="flex-1 min-w-0 flex flex-col p-6 lg:p-8 font-sans max-w-3xl mx-auto w-full">
      <button onClick={() => navigate(`/clients/${id}/new-document`)} className="text-sm text-slate-500 hover:text-slate-900 inline-flex items-center gap-1 mb-4">
        <ArrowLeft className="w-4 h-4" /> Voltar
      </button>
      <h1 className="font-heading text-3xl font-semibold text-slate-900">Procuração</h1>
      <p className="text-slate-500 mt-1">AD JUDICIA ET EXTRA, com poderes gerais para o foro.</p>

      <div className="mt-8 bg-white rounded-2xl border border-slate-100 p-6">
        <div className="text-sm mb-3">Deseja informar finalidade ou processo específico?</div>
        <div className="flex gap-3">
          <label className="flex items-center gap-2 text-sm">
            <input type="radio" name="esp" checked={!specific} onChange={() => setSpecific(false)} data-testid="proc-geral"/> Não, procuração geral
          </label>
          <label className="flex items-center gap-2 text-sm">
            <input type="radio" name="esp" checked={specific} onChange={() => setSpecific(true)} data-testid="proc-esp"/> Sim
          </label>
        </div>

        {specific && (
          <div className="mt-5 grid grid-cols-1 gap-4">
            <label><div className="text-xs text-slate-600 mb-1">Finalidade</div><input value={f.finalidade} onChange={(e)=>setF({...f,finalidade:e.target.value})} className="w-full h-10 px-3 rounded-lg bg-slate-50 border border-slate-200 text-sm"/></label>
            <label><div className="text-xs text-slate-600 mb-1">Processo</div><input value={f.processo} onChange={(e)=>setF({...f,processo:e.target.value})} className="w-full h-10 px-3 rounded-lg bg-slate-50 border border-slate-200 text-sm"/></label>
            <label><div className="text-xs text-slate-600 mb-1">Parte contrária</div><input value={f.parte_contraria} onChange={(e)=>setF({...f,parte_contraria:e.target.value})} className="w-full h-10 px-3 rounded-lg bg-slate-50 border border-slate-200 text-sm"/></label>
            <label><div className="text-xs text-slate-600 mb-1">Órgão</div><input value={f.orgao} onChange={(e)=>setF({...f,orgao:e.target.value})} className="w-full h-10 px-3 rounded-lg bg-slate-50 border border-slate-200 text-sm"/></label>
            <label><div className="text-xs text-slate-600 mb-1">Poderes específicos</div><textarea value={f.poderes_especificos} onChange={(e)=>setF({...f,poderes_especificos:e.target.value})} rows={3} className="w-full p-3 rounded-lg bg-slate-50 border border-slate-200 text-sm"/></label>
          </div>
        )}
      </div>

      <button data-testid="btn-gen-proc" onClick={submit} disabled={loading}
        className="mt-6 w-full gradient-primary text-white h-14 rounded-xl inline-flex items-center justify-center gap-2 hover:-translate-y-0.5 transition text-base font-medium">
        <Scale className="w-5 h-5"/> {loading ? "Gerando..." : "OK, GERAR PROCURAÇÃO"}
      </button>
    </div>
  );
}
